import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, ChevronDownIcon } from '@metarouter-private/mr-mui';

import { readableAction } from 'app/audit-logs/actions';

import auditLogPanelId from './auditLogPanelId';

const COLLAPSED_ROTATION = { transform: 'rotate(-90deg)' };

export default function AuditLogRowToggleButton({ row, expanded, onToggle }) {
  const accessibleName = `${expanded ? 'Hide' : 'Show'} field changes for ${readableAction(
    row.action
  )}, ${formatAccessibleTimestamp(row.timestamp)}`;

  return (
    <IconButton
      data-test-id="auditLogRowToggle"
      aria-expanded={expanded}
      aria-controls={auditLogPanelId(row.id)}
      aria-label={accessibleName}
      onClick={() => onToggle(row.id)}
    >
      <ChevronDownIcon style={expanded ? null : COLLAPSED_ROTATION} />
    </IconButton>
  );
}

function formatAccessibleTimestamp(date) {
  return new Intl.DateTimeFormat('en-US', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(date);
}

AuditLogRowToggleButton.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.string.isRequired,
    action: PropTypes.string.isRequired,
    timestamp: PropTypes.instanceOf(Date).isRequired,
  }).isRequired,
  expanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};
